module.exports = __webpack_public_path__ + "media/images/icon__paginationArrows@2x-cd50b7cc86e14cf2e9a877c10b6f7732.png";